import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mapTo, mergeMap } from 'rxjs/operators';
import { AuthService } from './core/auth/service/auth.service';
import { Subscription, zip } from 'rxjs';
import { RoleListServicePathConst, RoleMenuServicePathConst, RoleMyAccessServicePathConst } from './pages/role/shared/const';
import { RoleAccessModel, RoleMenuModel, RoleModel } from './pages/role/shared/model';
import { BaseService } from './core/base-service/service';
import { RoleAccessService } from '../app/core/auth/service/role-access.service';
import { Location } from '@angular/common';
import { ViewChild, TemplateRef, ElementRef, AfterViewInit } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppService } from '../app/layout/shared/services/app.service';
import { ApprovalPathConst, refreshTokenPathConst } from './pages/approval/shared/const/approval-path.const';
import { refreshTokenModel } from './pages/approval/shared/model/refreshtoken.model';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})

export class AppComponent {

  // Blokir semua context menu
  @HostListener('document:contextmenu', ['$event'])
  onContextMenu(event: MouseEvent) {
    event.preventDefault();
    return false;
  }

  // Blokir klik kanan (fallback)
  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    // Button 2 = right-click, Button 1 = middle, Button 0 = left
    if (event.button === 2) {
      event.preventDefault();
      return false;
    }

    // Mac alternative: Ctrl + Left Click
    if (event.ctrlKey && event.button === 0) {
      event.preventDefault();
      return false;
    }
  }

	private subscribers: Subscription[];

	idleState = 'Not started.';
	timedOut = false;
	lastPing?: Date = null;
	titles = 'angular-idle-timeout';

	public modalRef: BsModalRef;

	@ViewChild('childModal', { static: false }) childModal: ModalDirective;
	url: string;


	constructor(
		private authService: AuthService,
		private location: Location,
		private roleAccessService: RoleAccessService,
		private baseService: BaseService,
		public router: Router,
		private activatedRoute: ActivatedRoute,
		private title: Title,
		private idle: Idle, private keepalive: Keepalive,
   		private modalService: BsModalService, private appService: AppService
	) {

		this.idles();

	}

	idles() {

		this.idle.setIdle(900);
		this.idle.setTimeout(900);
		this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		this.idle.onIdleEnd.subscribe(() => {
		  this.idleState = 'No longer idle.'
		  this.reset();
		});

		this.idle.onTimeout.subscribe(() => {
		  this.childModal.hide();
		  this.idleState = 'Timed out!';
		  this.timedOut = true;
		  this.router.navigate(['/']);
		});

		this.idle.onIdleStart.subscribe(() => {
			this.idleState = 'You\'ve gone idle!'
			this.childModal.show();
		});

		this.idle.onTimeoutWarning.subscribe((countdown) => {
		  this.idleState = countdown + ' seconds!'
		});

		this.keepalive.interval(900);

		this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

		this.appService.getUserLoggedIn().subscribe(userLoggedIn => {
		  if (userLoggedIn) {
			this.idle.watch()
			this.timedOut = false;
		  } else {
			this.idle.stop();
		  }
		})

	}

	reset() {
		this.idle.watch();
		this.timedOut = false;
	  }

	  hideChildModal(): void {
		this.childModal.hide();
	  }


	stay() {

		const accesstoken = localStorage.getItem('EWPadmin.accessToken');
		const refereshtoken = localStorage.getItem('EWPadmin.refreshToken');

		this.url = refreshTokenPathConst;

		const bodyReq = new refreshTokenModel().clone({
				accesstoken
			});

			bodyReq.accessToken = accesstoken;
			bodyReq.refreshToken = refereshtoken;


		const subs = this.baseService.postData(this.url, bodyReq)
		.subscribe((resp) => {
		  if (resp.status === 200) {

			localStorage.setItem('EWPadmin.accessToken', resp.data.data.accessToken);
			localStorage.setItem('EWPadmin.refreshToken', resp.data.data.refreshToken);

			this.childModal.hide();
			this.reset();
			this.idle.stop();
		  }
			}, err => {

		});
	  }

	  logout() {
		this.childModal.hide();
		this.appService.setUserLoggedIn(false);
		this.router.navigate(['/']);
	  }

	ngOnInit(): void {
		this.subscribers = [];
		this.setTitlePage();
	}



	ngOnDestroy(): void {
		this.subscribers.forEach((each) => each.unsubscribe());
	}

	private setTitlePage() {
		const sub = this.router.events
		  .pipe(
			filter((e) => e instanceof NavigationEnd),
			mapTo(this.activatedRoute),
			map((route) => {
			  while (route.firstChild) {
				route = route.firstChild;
			  }
			  return route;
			}),
			filter((route) => route.outlet === 'primary'),
			mergeMap((route) => route.data),
		  )
			.subscribe((data) => {
			if (data['seo']) {
			  const seoData = data['seo'];
			  this.title.setTitle(seoData['title']);
			}
		  });

		  this.subscribers.push(sub);
	  }
}
